/* Kick Frame — productpagina, naar aanleiding van Clarity-opnames (4-11-2026).
   1. Vaste koopbalk ("sticky-buy") verschijnt zodra de echte knop "In winkelwagen" niet in beeld is.
      kickframe.js kijkt naar [data-buy-anchor]; die stond vóór de knop, dus als het anker nét in beeld
      was maar de knop eronder niet, zag je op een telefoon geen enkele koopknop. Anker nu ná de knop.
   2. Lijstkeuze: bij "Ingelijst" en "Met posterhanger" de meerprijs tonen ("+ €22") in plaats van een
      totaalprijs, zodat je niet alle combinaties hoeft af te klikken om de prijzen te vergelijken.
      De totaalprijs staat al groot bovenaan. */
(function () {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  // 1. anker achter de knop zetten
  var anchor = form.querySelector('[data-buy-anchor]');
  var buy = form.querySelector('button[type="submit"]');
  if (anchor && buy && buy.parentNode) buy.parentNode.insertBefore(anchor, buy.nextSibling);

  // 2. meerprijs per lijst
  var variants = [];
  try { variants = JSON.parse(document.querySelector('[data-product-json]').textContent); } catch (e) { return; }
  var fmt = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
  function money(cents) { return fmt.format(cents / 100).replace(/,00$/, ''); }

  function chosen() {
    var w = [];
    form.querySelectorAll('input[data-option-position]:checked').forEach(function (c) {
      w[Number(c.getAttribute('data-option-position')) - 1] = c.value;
    });
    return w;
  }
  function priceFor(input) {
    var w = chosen();
    w[Number(input.getAttribute('data-option-position')) - 1] = input.value;
    var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === w[i]; }); });
    return v ? v.price : null;
  }

  function apply() {
    var spans = form.querySelectorAll('[data-opt-price]');
    if (!spans.length) return;
    var base = null;
    spans.forEach(function (span, i) {
      var input = document.getElementById(span.parentNode.getAttribute('for'));
      if (!input) return;
      var p = priceFor(input);
      if (p == null) return;
      if (i === 0) { base = p; span.classList.remove('is-delta'); return; }
      if (base == null || p <= base) return;
      var txt = '+ ' + money(p - base);
      if (span.textContent !== txt) span.textContent = txt;
      span.classList.add('is-delta');
    });
  }

  // het inline-script in kf-product vult de totaalprijzen (ook na elke wijziging, met setTimeout 0)
  apply();
  form.addEventListener('change', function () { window.setTimeout(apply, 30); });
})();

/* 3. Foto groot bekijken. Clarity (4-11): bijna iedereen tikt op de poster om hem te bekijken,
      maar daar gebeurde niets. Tik op de foto → schermvullend, tik/knop om in te zoomen,
      vegen of pijlen naar de volgende foto (de thumbs), sluiten met ✕, Esc of de terugknop. */
(function () {
  var main = document.querySelector('.gallery-main');
  var img = main && main.querySelector('img');
  if (!img) return;
  var nl = /^nl/i.test(document.documentElement.lang || '');
  var T = nl ? { open: 'Foto vergroten', close: 'Sluiten', prev: 'Vorige foto', next: 'Volgende foto', hint: 'Tik om in te zoomen' }
             : { open: 'Enlarge photo', close: 'Close', prev: 'Previous photo', next: 'Next photo', hint: 'Tap to zoom' };

  function big(src) { return String(src || '').replace(/([?&])width=\d+/, '$1width=2048'); }
  function sources() {
    var list = [].map.call(document.querySelectorAll('.thumbs .thumb[data-full]'), function (b) { return big(b.getAttribute('data-full')); });
    return list.length ? list : [big(img.currentSrc || img.src)];
  }

  var css = ''
    + '.gallery-main img{cursor:zoom-in}'
    // linksonder boven "Aan je muur" (linksboven staat het Sale-label, rechtsboven op mobiel de thumbs)
    + '.kf-zoom-btn{position:absolute;left:10px;bottom:58px;z-index:3;width:34px;height:34px;border-radius:50%;border:0;background:rgba(10,18,16,.7);color:#fff;display:grid;place-items:center;cursor:pointer}'
    + '.kf-lb{position:fixed;inset:0;z-index:1000;background:rgba(5,9,8,.96);display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .2s}'
    + '.kf-lb.is-open{opacity:1}'
    + '.kf-lb-stage{position:absolute;inset:0;overflow:hidden;touch-action:pan-y pinch-zoom}'
    + '.kf-lb-stage.is-zoomed{overflow:auto;touch-action:auto;cursor:zoom-out}'
    + '.kf-lb-stage img{display:block;max-width:calc(100% - 24px);max-height:calc(100% - 110px);margin:auto;position:absolute;inset:0;object-fit:contain;cursor:zoom-in;user-select:none;-webkit-user-drag:none}'
    + '.kf-lb-stage.is-zoomed img{position:static;max-width:none;max-height:none;width:220%;margin:0}'
    + '.kf-lb button{position:absolute;z-index:2;border:0;border-radius:50%;width:44px;height:44px;background:rgba(255,255,255,.12);color:#fff;font-size:1.6rem;line-height:1;cursor:pointer}'
    + '.kf-lb-close{top:max(12px,env(safe-area-inset-top));right:12px}'
    + '.kf-lb-prev{left:10px;top:50%;margin-top:-22px}.kf-lb-next{right:10px;top:50%;margin-top:-22px}'
    + '.kf-lb-bar{position:absolute;left:0;right:0;bottom:max(14px,env(safe-area-inset-bottom));text-align:center;color:#fff;opacity:.75;font:500 .85rem/1.3 Inter,system-ui,sans-serif;pointer-events:none}'
    + 'html.kf-lb-lock,html.kf-lb-lock body{overflow:hidden}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  // klein vergrootglas op de foto, zodat het duidelijk is dat je erop kunt tikken
  var zb = document.createElement('button');
  zb.type = 'button'; zb.className = 'kf-zoom-btn'; zb.setAttribute('aria-label', T.open);
  zb.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21M10.5 7.5v6M7.5 10.5h6"/></svg>';
  main.appendChild(zb);

  var lb, stage, pic, bar, list, idx = 0;
  function show(i) {
    idx = (i + list.length) % list.length;
    stage.classList.remove('is-zoomed');
    pic.src = list[idx];
    bar.textContent = (list.length > 1 ? (idx + 1) + ' / ' + list.length + ' · ' : '') + T.hint;
  }
  function open() {
    list = sources();
    var cur = big(img.currentSrc || img.src).split('?')[0];
    var start = 0;
    list.forEach(function (s, i) { if (s.split('?')[0].replace(/^https?:/, '') === cur.replace(/^https?:/, '')) start = i; });

    lb = document.createElement('div');
    lb.className = 'kf-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
    lb.innerHTML = '<div class="kf-lb-stage"><img alt=""></div>'
      + '<button type="button" class="kf-lb-close" aria-label="' + T.close + '">&times;</button>'
      + (list.length > 1 ? '<button type="button" class="kf-lb-prev" aria-label="' + T.prev + '">&#8249;</button><button type="button" class="kf-lb-next" aria-label="' + T.next + '">&#8250;</button>' : '')
      + '<div class="kf-lb-bar"></div>';
    document.body.appendChild(lb);
    stage = lb.querySelector('.kf-lb-stage'); pic = stage.querySelector('img'); bar = lb.querySelector('.kf-lb-bar');
    pic.alt = img.alt || '';
    show(start);
    document.documentElement.classList.add('kf-lb-lock');
    window.requestAnimationFrame(function () { lb.classList.add('is-open'); });

    lb.querySelector('.kf-lb-close').addEventListener('click', function () { history.back(); });
    if (list.length > 1) {
      lb.querySelector('.kf-lb-prev').addEventListener('click', function () { show(idx - 1); });
      lb.querySelector('.kf-lb-next').addEventListener('click', function () { show(idx + 1); });
    }
    // tik op de foto = in/uitzoomen op die plek; tik naast de foto = sluiten
    stage.addEventListener('click', function (e) {
      if (e.target !== pic) { history.back(); return; }
      var r = pic.getBoundingClientRect();
      var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
      var z = stage.classList.toggle('is-zoomed');
      if (z) {
        stage.scrollLeft = fx * pic.offsetWidth - stage.clientWidth / 2;
        stage.scrollTop = fy * pic.offsetHeight - stage.clientHeight / 2;
      }
    });
    // vegen naar vorige/volgende (alleen als niet ingezoomd)
    var x0 = null, y0 = null;
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1 || stage.classList.contains('is-zoomed')) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 == null || list.length < 2) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(idx + (dx < 0 ? 1 : -1));
      x0 = null;
    });
    // terugknop van de telefoon sluit de foto i.p.v. de pagina te verlaten
    history.pushState({ kfLb: 1 }, '');
    window.addEventListener('popstate', close);
    document.addEventListener('keydown', onKey);
  }
  function onKey(e) {
    if (e.key === 'Escape') history.back();
    else if (e.key === 'ArrowLeft' && list.length > 1) show(idx - 1);
    else if (e.key === 'ArrowRight' && list.length > 1) show(idx + 1);
  }
  function close() {
    window.removeEventListener('popstate', close);
    document.removeEventListener('keydown', onKey);
    document.documentElement.classList.remove('kf-lb-lock');
    var el = lb; lb = null;
    if (!el) return;
    el.classList.remove('is-open');
    window.setTimeout(function () { el.remove(); }, 200);
  }

  img.addEventListener('click', open);
  zb.addEventListener('click', open);
})();
